// Roles referenced by application styles. Keep in sync with actual consumers.
export const USED_APPEARANCE_ROLES = [
  'priorityHigh.normal.icon',
  'priorityMedium.normal.icon',
  'priorityLow.normal.icon',
  'fieldHint.normal.text',
  'photoFrame.selected.border',
  'photoMain.normal.background',
  'photoMain.normal.icon',
  'photoMain.normal.border',
  'photoMain.selected.background',
  'photoMain.selected.icon',
  'photoMain.selected.border',
  'photoAi.normal.background',
  'photoAi.normal.icon',
  'photoAi.normal.border',
  'photoAi.selected.background',
  'photoAi.selected.icon',
  'photoAi.selected.border',
  'quickNavigation.normal.background',
  'quickNavigation.normal.text',
  'quickNavigation.normal.border',
  'breadcrumbs.focus.border',
  'breadcrumbs.hover.background',
  'breadcrumbs.hover.text',
  'breadcrumbs.normal.backdrop',
  'breadcrumbs.normal.background',
  'breadcrumbs.normal.border',
  'breadcrumbs.normal.text',
  'breadcrumbs.selected.background',
  'breadcrumbs.selected.text',
  'calendar.disabled.background',
  'calendar.disabled.backgroundEnd',
  'calendar.disabled.border',
  'calendar.disabled.shadow',
  'calendar.disabled.text',
  'calendar.normal.background',
  'calendar.normal.backgroundEnd',
  'calendar.normal.border',
  'calendar.normal.icon',
  'calendar.normal.shadow',
  'calendar.normal.text',
  'calendar.selected.background',
  'calendar.selected.border',
  'calendar.selected.text',
  'canvas.normal.background',
  'canvas.normal.backgroundEnd',
  'canvas.normal.muted',
  'canvas.normal.text',
  'card.focus.border',
  'card.hover.backdrop',
  'card.hover.border',
  'card.hover.shadow',
  'card.normal.backdrop',
  'card.normal.background',
  'card.normal.backgroundEnd',
  'card.normal.border',
  'card.normal.icon',
  'card.normal.muted',
  'card.normal.shadow',
  'card.normal.text',
  'card.selected.background',
  'card.selected.backgroundEnd',
  'card.selected.border',
  'card.selected.shadow',
  'changeAdded.normal.backdrop',
  'changeAdded.normal.background',
  'changeAdded.normal.backgroundEnd',
  'changeAdded.normal.border',
  'changeAdded.normal.shadow',
  'changeAdded.normal.text',
  'changeUpdated.normal.backdrop',
  'changeUpdated.normal.background',
  'changeUpdated.normal.backgroundEnd',
  'changeUpdated.normal.border',
  'changeUpdated.normal.muted',
  'changeUpdated.normal.shadow',
  'changeUpdated.normal.text',
  'checkbox.focus.border',
  'checkbox.focus.shadow',
  'checkbox.hover.background',
  'checkbox.hover.border',
  'checkbox.normal.background',
  'checkbox.normal.border',
  'checkbox.normal.muted',
  'checkbox.normal.shadow',
  'checkbox.normal.text',
  'checkbox.selected.background',
  'checkbox.selected.border',
  'danger.normal.background',
  'danger.normal.backgroundEnd',
  'danger.normal.border',
  'danger.normal.shadow',
  'danger.normal.text',
  'dialog.normal.backdrop',
  'dialog.normal.background',
  'dialog.normal.border',
  'dialog.normal.muted',
  'dialog.normal.shadow',
  'dialog.normal.text',
  'dropdown.disabled.background',
  'dropdown.disabled.shadow',
  'dropdown.disabled.text',
  'dropdown.error.border',
  'dropdown.focus.border',
  'dropdown.normal.background',
  'dropdown.normal.border',
  'dropdown.normal.icon',
  'dropdown.normal.muted',
  'dropdown.normal.shadow',
  'dropdown.normal.text',
  'dropdown.selected.background',
  'dropdown.selected.shadow',
  'dropdown.selected.text',
  'empty.normal.background',
  'empty.normal.backgroundEnd',
  'empty.normal.border',
  'empty.normal.icon',
  'empty.normal.muted',
  'empty.normal.text',
  'error.normal.background',
  'error.normal.backgroundEnd',
  'error.normal.border',
  'error.normal.text',
  'footer.normal.background',
  'footer.normal.border',
  'footer.normal.muted',
  'footer.normal.shadow',
  'footer.normal.text',
  'header.normal.background',
  'header.normal.text',
  'iconButton.hover.background',
  'iconButton.normal.text',
  'info.normal.background',
  'info.normal.border',
  'info.normal.text',
  'input.disabled.background',
  'input.disabled.border',
  'input.disabled.icon',
  'input.disabled.shadow',
  'input.disabled.text',
  'input.error.background',
  'input.error.border',
  'input.error.text',
  'input.focus.background',
  'input.focus.border',
  'input.focus.shadow',
  'input.focus.text',
  'input.hover.background',
  'input.normal.backdrop',
  'input.normal.background',
  'input.normal.backgroundEnd',
  'input.normal.border',
  'input.normal.icon',
  'input.normal.muted',
  'input.normal.shadow',
  'input.normal.text',
  'input.pressed.background',
  'input.pressed.text',
  'input.selected.background',
  'input.selected.border',
  'input.selected.text',
  'loading.normal.background',
  'loading.normal.backgroundEnd',
  'loading.normal.border',
  'loading.normal.shadow',
  'loading.normal.text',
  'media.normal.background',
  'media.normal.icon',
  'menu.focus.background',
  'menu.focus.text',
  'menu.hover.background',
  'menu.hover.border',
  'menu.normal.background',
  'menu.normal.border',
  'menu.normal.icon',
  'menu.normal.muted',
  'menu.normal.shadow',
  'menu.normal.text',
  'menu.pressed.background',
  'menu.selected.background',
  'navigation.focus.background',
  'navigation.focus.border',
  'navigation.focus.icon',
  'navigation.focus.text',
  'navigation.hover.background',
  'navigation.hover.icon',
  'navigation.hover.text',
  'navigation.normal.backdrop',
  'navigation.normal.background',
  'navigation.normal.backgroundEnd',
  'navigation.normal.border',
  'navigation.normal.icon',
  'navigation.normal.muted',
  'navigation.normal.shadow',
  'navigation.normal.text',
  'navigation.pressed.background',
  'navigation.pressed.icon',
  'navigation.pressed.text',
  'navigation.selected.background',
  'navigation.selected.icon',
  'navigation.selected.text',
  'primary.focus.border',
  'primary.normal.background',
  'primary.normal.backgroundEnd',
  'primary.normal.shadow',
  'primary.normal.text',
  'profile.normal.background',
  'profile.normal.backgroundEnd',
  'profile.normal.border',
  'profile.normal.icon',
  'profile.normal.muted',
  'profile.normal.shadow',
  'profile.normal.text',
  'radio.selected.background',
  'radio.selected.text',
  'scanButton.normal.background',
  'scanButton.normal.text',
  'scrollbar.normal.background',
  'scrollbar.normal.text',
  'search.normal.backdrop',
  'search.normal.background',
  'search.normal.backgroundEnd',
  'search.normal.border',
  'search.normal.shadow',
  'search.normal.text',
  'secondary.normal.backdrop',
  'secondary.normal.background',
  'secondary.normal.border',
  'secondary.normal.shadow',
  'secondary.normal.text',
  'success.normal.background',
  'success.normal.border',
  'success.normal.text',
  'surface.normal.backdrop',
  'surface.normal.background',
  'surface.normal.backgroundEnd',
  'surface.normal.border',
  'surface.normal.icon',
  'surface.normal.muted',
  'surface.normal.shadow',
  'surface.normal.text',
  'table.disabled.background',
  'table.error.background',
  'table.error.border',
  'table.focus.border',
  'table.hover.background',
  'table.hover.border',
  'table.hover.shadow',
  'table.hover.text',
  'table.normal.background',
  'table.normal.backgroundEnd',
  'table.normal.border',
  'table.normal.icon',
  'table.normal.muted',
  'table.normal.shadow',
  'table.normal.text',
  'table.selected.background',
  'table.selected.border',
  'table.selected.text',
  'tabs.focus.border',
  'tabs.hover.background',
  'tabs.hover.text',
  'tabs.normal.background',
  'tabs.normal.border',
  'tabs.normal.text',
  'tabs.selected.background',
  'tabs.selected.border',
  'tabs.selected.text',
  'toggle.focus.background',
  'toggle.focus.border',
  'toggle.focus.text',
  'toggle.normal.background',
  'toggle.normal.border',
  'toggle.normal.shadow',
  'toggle.normal.text',
  'tooltip.normal.background',
  'tooltip.normal.border',
  'tooltip.normal.shadow',
  'tooltip.normal.text',
  'warning.normal.background',
  'warning.normal.border',
  'warning.normal.icon',
  'warning.normal.text',
  'widget.normal.backdrop',
  'widget.normal.background',
  'widget.normal.backgroundEnd',
  'widget.normal.border',
  'widget.normal.muted',
  'widget.normal.shadow',
  'widget.normal.text',
] as const;
